import Countries from 'country-list';

// Kosovo has no ISO 3166 code. The app uses XK, registered in
// config/initializers/countries.rb; this module is the one place that maps XK
// onto the front-end vocabularies that spell it differently or lack it.

// The vendored Highmaps data (vendor/highmaps-world) predates the convention
// and keys Kosovo as KV, the legacy Natural Earth code for a disputed border.
// Only the map join uses this: point.code stays XK, because the map's click
// handler feeds it straight into a countries[] filter that the server resolves
// through the gem.
const MAP_CODES = { XK: 'KV' };

export function toMapCode(code) {
  return MAP_CODES[code] || code;
}

// The npm country-list package is ISO 3166-1 exactly, 249 entries, so the
// filter box could never offer Kosovo. The name is display-only: the field
// sends the code, which the server resolves through the gem, so this string
// labels a chip rather than matching anything. The duplication goes away if
// the field is ever served from /explorer/autocomplete like every other
// filter, which would retire this package too.
const EXTRA_COUNTRIES = [{ code: 'XK', name: 'Kosovo' }];

// Built once and frozen: both callers only filter it, and handing out a live
// reference to module state would let a future sort or push corrupt the list
// for everyone. The saved concat is noise; the freeze is the point.
const COUNTRY_OPTIONS = Object.freeze(Countries.getData().concat(EXTRA_COUNTRIES));

export function countryOptions() {
  return COUNTRY_OPTIONS;
}
